import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { StockReception } from 'types/models/StockReceipt';
import { getStockReception } from 'services/stockReceptionServices';
import StockReceptionForm from 'forms/StockReceptionForm';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedReception } = React.useContext(EditStockModuleContext);
  const [completeStockReception, setCompleteStockReception] = React.useState<StockReception | null>(null);

  React.useEffect(() => {
    if (!selectedReception) {
      history.replace('/private/stock/receptions');
      return;
    }

    let mounted = true;

    (async () => {
      const reception = await getStockReception(selectedReception.id);

      if (!mounted) return;

      if (!reception) {
        history.replace('/private/stock/receptions');
        return;
      }

      setCompleteStockReception(reception);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedReception, history]);

  if (!selectedReception) return <></>;
  if (!completeStockReception) return <div>{t('loading')}</div>;

  return <StockReceptionForm reception={completeStockReception} />;
};
